import React from "react";
import { motion } from "framer-motion";
import logo from "../../assets/logo.png"; // Import your logo

const Loader = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-[#0B1F3A] via-[#0d2647] to-[#0B1F3A] px-4"
    >
      <div className="relative flex items-center justify-center">
        {/* Outer Rotating Rings */}
        <motion.div
          className="h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 rounded-full border-4 border-[#D4AF37]/10"
          animate={{ rotate: 360 }}
          transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
        >
          <div className="h-full w-full rounded-full border-4 border-transparent border-t-[#D4AF37] animate-spin"></div>
        </motion.div>

        {/* Middle Ring */}
        <motion.div
          className="absolute h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 rounded-full border-4 border-[#D4AF37]/20"
          animate={{ rotate: -360 }}
          transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
        >
          <div className="h-full w-full rounded-full border-4 border-transparent border-b-[#f0d060] animate-spin"></div>
        </motion.div>

        {/* Inner Logo */}
        <motion.div
          className="absolute flex h-15 w-15 sm:h-15 sm:w-15 md:h-15 md:w-15 items-center justify-center rounded-xl sm:rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#f0d060] shadow-2xl overflow-hidden"
          whileHover={{ scale: 1.1 }}
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <img 
            src={logo} 
            alt="Kandha Security" 
            className="h-full w-full object-cover p-1.5 sm:p-2"
          />
        </motion.div>
      </div>

      {/* Company Name with Gradient */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="mt-6 sm:mt-7 md:mt-8 text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-wide text-center"
      >
        <span className="bg-gradient-to-r from-[#D4AF37] via-[#f0d060] to-[#D4AF37] bg-clip-text text-transparent">
          Kandha Security Professional Security Solutions
        </span>
      </motion.h2>

      {/* Loading Text with Dots */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="mt-2 sm:mt-3 flex items-center gap-1"
      >
        <span className="text-xs sm:text-sm uppercase tracking-[6px] sm:tracking-[8px] text-[#D4AF37]/70">
          Loading
        </span>
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0 }}
          className="text-[#D4AF37] text-sm sm:text-base"
        >
          .
        </motion.span>
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0.3 }}
          className="text-[#D4AF37] text-sm sm:text-base"
        >
          .
        </motion.span>
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0.6 }}
          className="text-[#D4AF37] text-sm sm:text-base"
        >
          .
        </motion.span>
      </motion.div>

      {/* Progress Bar */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        transition={{ duration: 2, ease: "easeInOut" }}
        className="mt-4 sm:mt-5 md:mt-6 h-1 w-32 sm:w-40 md:w-48 overflow-hidden rounded-full bg-[#D4AF37]/20"
      >
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-[#D4AF37] to-[#f0d060]"
          animate={{ x: ["-100%", "100%"] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        />
      </motion.div>
    </motion.div>
  );
};

export default Loader;